import {useIcon} from '../icon/useIcon'
import {Show, createEffect} from 'solid-js'
import './newLogin.css'
import {useConfig} from '../config/useConfig'
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import {useSpatialNavigation} from '../../spatialNavigation'
import {onMount} from 'solid-js'
import {isPlatform} from '../../utils'
import {useI18n} from '../../i18n'
import UserLoginForm from '../userLoginForm/userLoginForm'
import LoginQrForm from '../loginQRForm/loginQrForm'
import {useDispatch} from '../../store'

interface NewLoginProps {
    onClickLoginButton?: any
    setUsernameOrEmail?: any
    usernameOrEmail?: any
    onClickUsernameButton?: any
}

export const NewLogin = (props: NewLoginProps) => {
    const {getConfig} = useConfig()
    const icons = useIcon()
    const {setFocus} = useSpatialNavigation()

    onMount(() => {
        if (!isPlatform('laptop')) {
            setFocus(`loginsbutton`)
        }
    })

    return (
        <FocusGroupProvider id={`logintvtab-screen`} class={`new-logintvtab-screen`}  focusKey={`logintvtab-screen`} onFocus={() => {}}>
            <div
             style={
                getConfig()?.client === 'starhub'
                  ? {
                    height: '100vh',
                    'background-image': `url(${icons.get('LoginBackdrop')})`,
                    'background-size': 'cover',
                    display: 'flex',
                    'justify-content': 'center',
                    'align-items': 'center',
                    }
                  : {}
              }
            >
                <div
                    style={{
                        display: 'flex',
                        'flex-direction': 'column',
                        'align-items': 'center',
                    }}
                >
                    <Show when={getConfig().userAuthType === 'BOTH'}>
                        <div class="client_logo_loading_logout_screen"></div>
                    </Show>
                    <div
                        style={{
                            display: 'flex',
                            // 'margin-top': '70px',
                            width: '100%',
                            'justify-content': 'center',
                        }}
                    >
                        {
                            <Show when={getConfig().userAuthType === 'QR' || getConfig().userAuthType === 'BOTH'}>
                                <div style={{width: '48%', display: 'flex', 'justify-content': 'center'}}>
                                    <LoginQrForm />
                                </div>
                            </Show>
                        }
                        {
                            <Show when={getConfig().userAuthType === 'BOTH'}>
                                <div class="center-container">
                                    <div class="vertical-line-login" />
                                    <div class="or">or</div>
                                    <div class="vertical-line-login" />
                                </div>
                            </Show>
                        }
                        {
                            <Show when={getConfig().userAuthType === 'LOGIN' || getConfig().userAuthType === 'BOTH'}>
                                <div
                                    style={{
                                        // width: '58%',
                                        display: 'flex',
                                        'justify-content': 'center',
                                    }}
                                >
                                    <UserLoginForm
                                        onClickLoginButton={props.onClickLoginButton}
                                        setUsernameOrEmail={props.setUsernameOrEmail}
                                        usernameOrEmail={props.usernameOrEmail}
                                        onClickUsernameButton={props?.onClickUsernameButton}
                                    />
                                </div>
                            </Show>
                        }
                    </div>
                </div>
            </div>
        </FocusGroupProvider>
    )
}
